import api from "./api";
import {iniciarRequisicao} from "@/helpers"

class ProdutoAPI {
  async getRaioXProdutoChart(headers, params) {
    const response = await api.get("/get_raio_x_produto_chart", {
      headers,
      params
    });
    return response;
  }

  async getRaioXProdutoInfo(headers, params) {
    const response = await api.get("/get_raio_x_produto_info", {
      headers,
      params
    });
    return response;
  }

  async setLoteMinimo(headers, params) {
    const response = await api({
      method: "post",
      url: "/set_lote_minimo",
      headers,
      data: params
    });
    return response;
  }

  async getImagemProduto(headers, params) {
    return await api.get("/produto/imagem", {headers, params});
  }

  async getProdutosParametrizacaoCobertura(headers, params) {
    return await api({
      method: "post",
      url: "/drp/parametrizacao/cobertura/produtos",
      headers,
      data: params
    })
  }

  async setParametrizacaoMultiplosProdutos(headers, params) {
    return await api({
      method: "post",
      url: "/drp/produto/parametrizacao/multipla",
      headers,
      data: params
    })
  }

  async getProdutosSobDemanda(headers, params){
    return await api({
      method: "post",
      url: "/get_produtos_limitados_por_pesquisa",
      headers,
      data: params
    })
  }

  async getDetalhesProduto(params) {
    const headers = iniciarRequisicao();

    return await api.get('/detalhes/produto', {params, headers})
  }

  async getCaracteristicasProduto(id_produto, id_grupo, filial, produto_eh_combinacao, produto_eh_categoria, ativar_filtro_revenda_direta = false) {
    const headers = iniciarRequisicao();

    const params = {
      produto_eh_combinacao,
      produto_eh_categoria,
      ativar_filtro_revenda_direta,
    };

    return await api.get(`/caracteristicas/produto/${id_produto}/grupo/${id_grupo}/filial/${filial || 9999}`, {params, headers})
  }
}

export default new ProdutoAPI();
